import { CommonModule, NgClass } from '@angular/common'
import { Component, DOCUMENT, HostListener, Inject, OnInit } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { LanguageSwitcherWidget, ThemeSwitcherWidget, ToggleThemeService } from '@corporate-tailwind/widget'
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-order-navbar',
    imports: [CommonModule, RouterLink, RouterLinkActive, NgClass, LanguageSwitcherWidget, ThemeSwitcherWidget, TranslateModule],
    templateUrl: './order-navbar.component.html',
    styleUrl: './order-navbar.component.scss'
})
export class OrderNavbarComponent implements OnInit {
    constructor(
        public _toggleThemeService: ToggleThemeService
    ) { }

    ngOnInit(): void {
        //-->remplacement par isDark dans toggleService
        // this.updateLogo()

        // // Optionnel : écouter les changements de thème si tu ajoutes/enlèves `dark` dynamiquement
        // const observer = new MutationObserver(() => this.updateLogo())
        // observer.observe(this.document.documentElement, {
        //     attributes: true,
        //     attributeFilter: ['class'],
        // })
    }

    // Toggle Class
    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied
    }

    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll')
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (scrollPosition >= 50) {
            this.isSticky = true
        } else {
            this.isSticky = false
        }
    }

    //-->remplacement par isDark dans toggleService
    // public isDark() : boolean{
    //     return this.document.documentElement.classList.contains('dark');
    // }
    // private updateLogo(): void {
    //     const hasDark = this.document.documentElement.classList.contains('dark')
    //     this.logoSrc = hasDark
    //         ? 'images/logo_loomisFx.png' //'images/logo_loomisFx_dark.png'
    //         : 'images/logo_loomisFx.png'
    // }
}
